import { useState, useCallback } from 'react';
import LandingScheduleService from './LandingScheduleService';

function useManageLandingSchedule() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async (year, month) => {
    setIsLoading(true);
    try {
      const response = await LandingScheduleService.getLandingScheduleImages({
        year,
        month,
      });
      setItems(response.data || []);
      setError(null);
    } catch (err) {
      setError(err);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const upsertImage = async ({ year, month, isAir, file }) => {
    setIsLoading(true);
    try {
      await LandingScheduleService.upsertLandingScheduleImage({
        year,
        month,
        isAir,
        file,
      });
      await refresh(year, month);
      return true;
    } catch (err) {
      console.error(err);
      setError(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const remove = async (id, year, month) => {
    setIsLoading(true);
    try {
      await LandingScheduleService.deleteLandingScheduleImage(id);
      await refresh(year, month);
      return true;
    } catch (err) {
      console.error(err);
      setError(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    items,
    isLoading,
    error,
    refresh,
    upsertImage,
    remove,
  };
}

export default useManageLandingSchedule;
